





























































































































































































import { Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import moment from 'moment'
import {
  WarehouseLocationServiceProxy,
  WarehouseMaterialStockServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import { WorkInProgressServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
const winpsp = new WorkInProgressServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
const whmssp = new WarehouseMaterialStockServiceProxy()

const columns = [
  {
    title: 'page_plan_warehousing_process',
    dataIndex: 'processCode',
    scopedSlots: { customRender: 'processCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_type',
    dataIndex: 'materialType',
    scopedSlots: { customRender: 'materialType' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_specifications',
    dataIndex: 'specification',
    scopedSlots: { customRender: 'specification' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_unit',
    dataIndex: 'unit',
    scopedSlots: { customRender: 'unit' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_to_stockInNum',
    dataIndex: 'number',
    scopedSlots: { customRender: 'number' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_remark',
    dataIndex: 'remarks',
    scopedSlots: { customRender: 'remarks' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'areaId',
    scopedSlots: { customRender: 'areaId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'locationId',
    ellipsis: true,
    scopedSlots: { customRender: 'locationId' }
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      cacheData: [],
      dayTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      locationList: [], // 库位列表
      loading: false
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    allAreaList: {
      type: Array,
      default: () => []
    },
    employeesList: {
      type: Array,
      default: () => []
    },
    treeList: {
      type: Array,
      default: () => []
    },
    materialList: {
      type: Array,
      default: () => []
    },
    currentWork: {
      type: Object,
      default: () => ({})
    },
    plan: {
      type: Object,
      default: () => ({})
    },
    currentData: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.dataSource = []
          const { currentData, dataSource } = this
          const newData = {
            key: 1,
            processCode: currentData.processCode,
            processId: currentData.id,
            processName: currentData.processName,
            materialType: '',
            materialCode: '',
            materialName: '',
            specification: '',
            unit: '',
            number: '',
            remarks: '',
            areaId: '',
            locationId: ''
          }
          this.dataSource = [...dataSource, newData]
          this.cacheData = this.dataSource
          console.log(this.dataSource)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    moment,
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let num = 0
      if (column === 'areaId') {
        whlsp.listWarehouseLocationByMaterial(value, '', record.materialId).then((res) => {
          this.locationList = res
        })
      }
      if (target) {
        target[column] = value
        if (column === 'areaId') {
          const area = this.allAreaList.find((res) => res.id === value)
          console.log(area)
          target['area'] = area.name
          target['locationId'] = ''
          target['location'] = ''
        }
        this.dataSource = newData
      }
    },
    changeMaterial(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      const material = this.materialList.find((res) => res.id === value)
      if (target) {
        target['materialId'] = material.id
        target['materialName'] = material.name
        target['materialType'] = material.typeName
        target['specification'] = material.standardModel
        target['stuff'] = material.stuff
        target['unit'] = material.unit
        target[column] = material.code
        target['areaId'] = ''
        target['area'] = ''
        target['locationId'] = ''
        target['location'] = ''
        this.dataSource = newData
      }
    },
    changeLocationId(value, record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let same = false
      newData.forEach((res) => {
        if (res.toLocationId === value && record.id === res.id) {
          same = true
        }
      })
      if (same) {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_be_same'))
        return
      }
      if (target) {
        let num = 0
        whmssp.listWarehouseMaterialStock(value, record.materialId).then((res) => {
          if (res && res.length > 0) {
            num = res[0].locationNum
            target['stockNumber'] = num
          } else {
            target['stockNumber'] = num
          }
        })
        target['locationId'] = value
        const area = this.locationList.find((res) => res.id === value)
        console.log(area)
        target['location'] = area.warehouseLocationName || area.name
        this.dataSource = newData
      }
    },
    close() {
      this.form.resetFields()
      this.dataSource = []
      this.cacheData = []
      this.$emit('close')
    },
    save() {
      let mesg = 0
      this.dataSource.forEach((element, index) => {
        if (element.materialCode === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_materialcode'))
          mesg = mesg + 1
          return
        }
        if (element.materialName === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_materialmame'))
          mesg = mesg + 1
          return
        }
        if (element.areaId === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_area'))
          mesg = mesg + 1
          return
        }
        if (element.locationId === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_location'))
          mesg = mesg + 1
          return
        }
        if (element.number === undefined || element.number === null || element.number === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_stock_number'))
          mesg = mesg + 1
          return
        }
      })
      if (mesg > 0) return
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          const list = this.dataSource[0]
          delete list.id
          delete list.key
          values.receivingTime = dayjs(values.receivingTime).format('YYYY-MM-DD HH:mm:ss')
          values.planId = this.plan.id
          values.orderId = this.currentWork.id
          values.inStockDTO = list
          winpsp
            .workInProgressInStock(values)
            .then(() => {
              this.form.resetFields()
              this.dataSource = []
              this.cacheData = []
              this.$emit('reload')
              this.loading = false
              this.$message.success(this.$t('save_success'))
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
})
